import { createLogic } from 'redux-logic';
import { normalize, schema } from 'normalizr';
import { get, find, filter, map, camelCase } from 'lodash';
import { decorateProduct } from 'decorators';
import { GRADUATION_DATA } from '../constants';

// Action Types
const FETCH = '@@app/product/FETCH';
const FETCH_SUCCESS = '@@app/product/FETCH_SUCCESS';
const FETCH_ERROR = '@@app/product/FETCH_ERROR';
const CANCEL = '@@app/product/CANCEL';

// Initial State
export const initialState = {
  entities: {
    products: {},
    weeks: {},
    workouts: {},
  },
  loading: false,
  result: 0,
};

// Observables
const productfetchLogic = createLogic({
  type: FETCH,
  cancelType: CANCEL,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR,
  },
  process({ action, httpClient }) {
    const { voomeProductId, startedAt } = action.payload;

    return httpClient
      .get(`/v1/voome/products/${voomeProductId}`)
      .then(({ data }) => {
        const workout = new schema.Entity('workouts');
        const week = new schema.Entity('weeks', { workouts: [workout] });
        const products = new schema.Entity('products', { weeks: [week] });
        return normalize(decorateProduct(data, startedAt), products);
      });
  },
});

export const productLogic = [productfetchLogic];

// Selectors
export const selectProducts = state => {
  return state.entities.products;
};

export const selectProduct = (state, id) => {
  return get(selectProducts(state), id || state.result);
};

export const selectWeeks = state => {
  return state.entities.weeks;
};

export const selectWeek = (state, weekNumber) => {
  return find(selectWeeks(state), { weekNumber });
};

export const selectDefaultMealPlanId = (state, weekNumber, isVegetarian) => {
  const week = selectWeek(state, weekNumber);

  if (week && week.mealPlan) {
    return isVegetarian ? week.vegetarianMealPlan.id : week.mealPlan.id;
  }
};

export const selectMealPlanIsDefault = (state, weekNumber, mealPlanId) => {
  const week = selectWeek(state, weekNumber);

  if (week && week.mealPlan) {
    return (
      mealPlanId === week.vegetarianMealPlan.id ||
      mealPlanId === week.mealPlan.id
    );
  }
};

export const selectWorkouts = state => {
  return state.entities.workouts;
};

export const selectWeekWorkouts = (state, weekNumber) => {
  const week = selectWeek(state, weekNumber);
  const workouts = selectWorkouts(state);

  if (!week || !workouts) {
    return;
  }

  return map(week.workouts, id => {
    return workouts[id];
  });
};

export const selectProductBackParams = (state, router) => {
  const { prevParams, prevState } = router;
  const { name } = prevState;
  const params = { ...prevParams };

  if (!params.voomeProductId || !params.weekNumber) {
    const product = selectProduct(state);

    if (product) {
      params.voomeProductId = product.id;
      params.weekNumber =
        product.currentWeek > product.weeks.length ? 1 : product.currentWeek;
    }
  }

  if (name === 'program.week.mealPlan') {
    return {
      title: 'Meal Plan',
      href: router.href('program.week.mealPlan', params),
    };
  } else {
    return {
      title: `Week ${params.weekNumber}`,
      href: router.href('program.week.detail', params),
    };
  }
};

// Helpers
export const getGraduationData = title => {
  return GRADUATION_DATA[camelCase(title)] || GRADUATION_DATA.fallback;
};

// Action Creators
export const fetchProduct = (voomeProductId, startedAt) => {
  return { type: FETCH, payload: { voomeProductId, startedAt } };
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH:
      return {
        ...state,
        loading: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        entities: payload.entities,
        loading: false,
        result: payload.result,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/logic/product.js